<div class="main-content table-page table-page--compact dashboard-tareas-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Dashboard de Tareas</h1>
        <p>Distribución semanal de horas por colaborador y su detalle diario.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary dashboard-tareas-page__export-btn" (click)="exportTable()">
          <i class="material-icons">download</i>
          <span>Exportar Excel</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre colaborador</mat-label>
              <input matInput [(ngModel)]="nombre" (keydown.enter)="aplicarFiltros()" aria-label="Nombre colaborador" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre tarea</mat-label>
              <input matInput [(ngModel)]="nombreTarea" (keydown.enter)="aplicarFiltros()" aria-label="Nombre tarea" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Área</mat-label>
              <mat-select [(ngModel)]="idArea" (selectionChange)="aplicarFiltros()">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option *ngFor="let area of areas" [value]="area.id">{{ area.area }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Cliente</mat-label>
              <mat-select [(ngModel)]="idCliente" (selectionChange)="filterProjectoCliente()">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">{{ cliente.razonsocial }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Proyecto</mat-label>
              <mat-select [(ngModel)]="idProyecto" (selectionChange)="aplicarFiltros()">
                <mat-option [value]="''">Todos</mat-option>
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="proyectoCtrl"
                    [placeholderLabel]="'Buscar proyecto'"
                    [noEntriesFoundLabel]="'No existe proyecto'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let proyecto of filteredProyectos | async" [value]="proyecto.id">{{ proyecto.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Inicio</mat-label>
              <input matInput [matDatepicker]="pickerInicio" readonly [(ngModel)]="fec_ini" (dateChange)="consultaListaSemanal()" [max]="maxDate" aria-label="Inicio" />
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicio></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Fin</mat-label>
              <input matInput [matDatepicker]="pickerFin" readonly [(ngModel)]="fec_fin" (dateChange)="consultaListaSemanal()" [min]="minDate" aria-label="Fin" />
              <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
              <mat-datepicker #pickerFin></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="clearProjectFilter()">
            <i class="material-icons">filter_alt_off</i>
            <span>Limpiar proyecto</span>
          </button>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiaFiltros()">
            <i class="material-icons">clear</i>
            <span>Limpiar filtros</span>
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="aplicarFiltros()">
            <i class="material-icons">search</i>
            <span>Aplicar filtros</span>
          </button>
        </div>
      </div>

      <div class="table-page__toolbar dashboard-tareas-page__week-nav">
        <div class="dashboard-tareas-page__week-copy">
          <span class="dashboard-tareas-page__week-label">Semana visible</span>
          <strong>{{ getWeekRangeLabel() }}</strong>
        </div>

        <div class="table-page__toolbar-actions dashboard-tareas-page__week-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="consultaPreviousWeek()" [disabled]="!previous">
            <i class="material-icons">chevron_left</i>
            <span>Anterior</span>
          </button>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="consultaNextWeek()" [disabled]="next">
            <span>Siguiente</span>
            <i class="material-icons">chevron_right</i>
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table id="dashboardTareasTable" class="table-page__table table-page__table--xwide" *ngIf="listaProyeccion.length > 0; else dashboardEmptyState">
          <thead>
            <tr>
              <th>Colaborador</th>
              <th *ngFor="let dayName of dayNames; let dayIndex = index">
                <div class="dashboard-tareas-page__day-head">
                  <strong>{{ dayName }}</strong>
                  <span>{{ getWeekDate(dayIndex) | date : 'dd/MM' }}</span>
                </div>
              </th>
              <th>Total Hrs.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of listaProyeccion">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ row.persona.nombreCompleto }}</strong>
                  <span class="table-page__subtext">Usuario {{ row.usuario?.id || '-' }}</span>
                </div>
              </td>

              <td *ngFor="let dayName of dayNames; let dayIndex = index" class="dashboard-tareas-page__day-cell">
                <button type="button" class="dashboard-tareas-page__day-card" (click)="viewDetail(row.persona.nombreCompleto, row.usuario.id, getWeekDate(dayIndex))">
                  <span class="dashboard-tareas-page__day-hours">{{ getDayTrackedHours(row, dayIndex) }} hrs.</span>
                  <span class="dashboard-tareas-page__day-meta">{{ getDayStatus(row, dayIndex) }}</span>
                  <span class="dashboard-tareas-page__day-bar">
                    <span class="dashboard-tareas-page__day-fill" [ngStyle]="{ 'background-color': getDayColor(row, dayIndex) }"></span>
                  </span>
                </button>
              </td>

              <td class="dashboard-tareas-page__total-cell">{{ row.usuario.horasTrabajadasStr }} hrs.</td>
            </tr>
          </tbody>
        </table>

        <ng-template #dashboardEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else dashboardLoadingState">
            <i class="material-icons">view_week</i>
            <strong>No se encontraron proyecciones semanales</strong>
            <span>Ajuste los filtros o cambie de semana para consultar otra ventana de trabajo.</span>
          </div>
        </ng-template>

        <ng-template #dashboardLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando proyección semanal...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} colaboradores</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">Inicio</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">Anterior</button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else dashboardPagerEllipsis" type="button" class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>
            <ng-template #dashboardPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">Último</button>
        </div>
      </div>
    </section>
  </div>
</div>
